import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  const faqs = [
    {
      question: "Who is eligible for StaffAbility services?",
      answer: "StaffAbility serves justice-involved individuals, including those with criminal histories, individuals in recovery, and others facing barriers to employment. We work with people at all stages of their reentry journey, from those currently incarcerated preparing for release to those who have been in the community for years."
    },
    {
      question: "What services does StaffAbility provide to job seekers?",
      answer: "We provide comprehensive employment support including job placement assistance, skills training, interview preparation, resume development, workplace mentoring, transportation assistance, professional clothing, and ongoing support to ensure job retention and career advancement."
    },
    {
      question: "How do employers benefit from partnering with StaffAbility?",
      answer: "Employers gain access to motivated, pre-screened candidates, reduce hiring costs and turnover, receive ongoing support for successful placements, and make a positive community impact. Our clients often show higher retention rates and strong work ethic due to their appreciation for second chances."
    },
    {
      question: "Is there a cost for StaffAbility services?",
      answer: "No, all services are provided free of charge to job seekers. Our nonprofit model is supported through grants, donations, and partnerships. Employers also receive our services at no cost as part of our community mission."
    },
    {
      question: "How long does the job placement process take?",
      answer: "The timeline varies based on individual circumstances, but most clients are placed within 30-90 days of completing our intake process. We focus on finding the right fit rather than rushing placements, which leads to better long-term outcomes."
    },
    {
      question: "What types of jobs do you help people find?",
      answer: "We work across many industries including manufacturing, retail, food service, construction, healthcare support, warehouse/logistics, customer service, and office administration. We match positions based on individual skills, interests, and career goals."
    },
    {
      question: "Do you provide training programs?",
      answer: "Yes, we offer various training programs including soft skills development, interview preparation, workplace readiness, basic computer skills, and industry-specific certifications. We also connect clients with community college and vocational training programs."
    },
    {
      question: "How can I volunteer with StaffAbility?",
      answer: "We welcome volunteers in many capacities including mentoring, job coaching, skills training, administrative support, and special events. Complete our volunteer application, and we'll match you with opportunities that fit your skills and availability."
    },
    {
      question: "What makes StaffAbility different from other employment agencies?",
      answer: "We specialize in serving justice-involved individuals with comprehensive wraparound services, ongoing support, and advocacy. Our team understands the unique challenges our clients face and works closely with employers to ensure successful placements and retention."
    },
    {
      question: "How can my organization become an employer partner?",
      answer: "Complete our employer partnership application to begin the process. We'll schedule a consultation to understand your hiring needs, provide information about our services, and develop a customized partnership plan that works for your organization."
    },
    {
      question: "Do you provide support after job placement?",
      answer: "Absolutely. We provide ongoing support for both employees and employers for the first 90 days and beyond as needed. This includes check-ins, problem-solving assistance, career development planning, and additional training if required."
    },
    {
      question: "What geographic areas do you serve?",
      answer: "We primarily serve the Waterloo/Cedar Falls area and surrounding communities in Iowa. However, we're expanding our reach and may be able to assist with referrals to similar organizations in other areas."
    }
  ];

  return (
    <div className="bg-white p-8 rounded-lg shadow-md max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold mb-6 text-slate-900">Frequently Asked Questions</h2>
      <p className="text-slate-600 mb-8">
        Find answers to common questions about StaffAbility's services, programs, and partnerships.
      </p>

      <Accordion type="single" collapsible className="w-full">
        {faqs.map((faq, index) => (
          <AccordionItem key={index} value={`item-${index}`}>
            <AccordionTrigger className="text-left">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="text-slate-600">
              {faq.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <div className="mt-8 p-6 bg-primary-50 rounded-lg">
        <h3 className="text-lg font-semibold text-primary-900 mb-2">Still have questions?</h3>
        <p className="text-primary-700 mb-4">
          Can't find what you're looking for? Our team is here to help.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href="tel:(319) 493-7201"
            className="inline-flex items-center justify-center px-4 py-2 border border-primary-300 rounded-md shadow-sm bg-white text-primary-700 hover:bg-primary-50 transition-colors"
          >
            Call us: (319) 493-7201
          </a>
          <a
            href="mailto:contact@staffability.org"
            className="inline-flex items-center justify-center px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors"
          >
            Email: contact@staffability.org
          </a>
        </div>
      </div>
    </div>
  );
}